/**
 * PlaceholderPage.jsx
 * Componente genérico para páginas en desarrollo
 */
import React from 'react';
import { Result, Button, Card, Space, Typography } from '@arco-design/web-react';
import { IconCodeBlock } from '@arco-design/web-react/icon';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

const PlaceholderPage = ({
  title,
  description,
  icon = <IconCodeBlock style={{ fontSize: 64, color: '#165DFF' }} />,
  showBackButton = true
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  const displayTitle = title || t('feedback.placeholder');
  const displayDescription = description || t('feedback.placeholderDesc');

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 'calc(100vh - 200px)',
      padding: '24px'
    }}>
      <Card style={{ maxWidth: 600, width: '100%' }}>
        <Result
          status={null}
          icon={icon}
          title={<Title heading={4}>{displayTitle}</Title>}
          subTitle={
            <Space direction="vertical" size="medium">
              <Text>{displayDescription}</Text>
              <Text type="secondary" style={{ fontSize: 14 }}>
                {t('feedback.placeholderStructure')}
              </Text>
            </Space>
          }
          extra={
            showBackButton && (
              <Space>
                <Button type="primary" onClick={() => navigate(-1)}>
                  {t('actions.back')}
                </Button>
                <Button onClick={() => navigate('/')}>
                  {t('actions.goToHome')}
                </Button>
              </Space>
            )
          }
        />
      </Card>
    </div>
  );
};

export default PlaceholderPage;
